module.exports = __webpack_public_path__ + "img/ch-education.a246bb2c.jpg";